import React, { Component } from 'react';
import {
    Link , NavLink
} from 'react-router-dom';
import SaveIcon from '@material-ui/icons/ArrowDropDown';
import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import seal1 from "../../images/VeriSign_transparent.png";
import seal2 from '../../images/visa_transparent.png';
import footerlogo from '../../images/footerlogo.png';
import { LaptopWindows } from '@material-ui/icons';
class SubFooter extends Component {
       constructor(props) {
        super(props);
        this.state = {
            anchorEl: null,
            anchorE2: null,
            open: false,
        }

        // this.handleActive = this.handleActive.bind(this)
        // this.handleClose = this.handleClose.bind(this)
    }
    handleClick = event => {
        this.setState({ anchorEl: event.currentTarget });
    };


    handleClick1 = event => {
        this.setState({ anchorE2: event.currentTarget , open : true });
    };

    handleClose1 = () => {
        this.setState({ open : false , anchorE2: null  },()=>{
            console.log("Calling close")
        });
    };
    handleClose2 = () => {
        this.setState({ anchorEl: null });
    };
    render() {
        const { anchorEl, anchorE2  } = this.state;

        return (
            <div style={{}}>
                <div className="sub-footer  col-sm-12 ">
                    <div className="container">
                        <div className='row bgfooter' >
                            <div className='col-sm-6 Copyright mt-3 pb-2'>
                                <div className="col-md-12 d-flex"><p style={{fontSize: '15px'}}>Copyright Oxygen Global 2025. All Right Reserved </p></div>
                                {/* <div className="col-md-12 d-flex"><img src={footerlogo} className='logoreversed' style={{ height: '40px',  marginTop: '20px'}} /></div> */}
                            </div>
                            <div className='col-sm-6 mt-2 d-flex footerlinks'>
                               
                                {
                                    localStorage.getItem('landing') === "false" &&
                                    <Link to="/terms-&-conditionsmain" target={"_blank"}>Terms & Conditions</Link>
                                }
                                {(localStorage.getItem('landing') === "true" && localStorage.getItem('pform')) &&
                                <React.Fragment >
                                <Button
                                    aria-owns={anchorE2 ? 'simple-menu' : undefined}
                                    aria-haspopup="true"
                                    onClick={this.handleClick1}
                                    style={{ textTransform: 'none', color: '#fff', fontWeight: 'normal' , textDecoration : 'underline' , marginTop: "-10px" }}
                                >
                                Terms & Conditions  <SaveIcon />
                                </Button>
                                <Menu
                                    id="simple-menu"
                                    anchorEl={anchorE2}
                                    //open={Boolean(anchorE2)}
                                    open={this.state.open}
                                    onWheel={this.handleClose1}
                                    onClose={this.handleClose1}
                                    onRequestClose={this.handleClose1}
                                    // onFocus={(e) => e.target.addEventListener("wheel", function (e) { e.preventDefault() }, { passive: false })}
                                >
                                    <NavLink to="/terms-&-conditionprod" onClick={this.handleClose1} target={"_blank"}> <MenuItem>KlickEx Money Card - Terms and Conditions</MenuItem></NavLink>
                                    <NavLink to="/terms-&-conditiondigiwallet" onClick={this.handleClose1}  target={"_blank"}><MenuItem>KlickEx Money Card Digital Wallet - Terms and Conditions</MenuItem></NavLink>
                                </Menu>
                                
                                </React.Fragment>
                                    // <Link to="/terms-&-conditionsmain" target={"_blank"}>Terms & Conditions</Link>
                                }

                                <Link to="/privacy-policy" target={"_blank"} >Privacy Policy</Link>
                                <Link to="/security-awareness" target={"_blank"} >Security Awareness</Link>

                                {/* <Link to="/">POS</Link>
                                <Link to="/">Notices</Link> */}

                                {/* <Link to="/pds">PDS</Link> */}
                            </div>
                            {/* <Link to="/terms-&-conditions">Terms & Conditions</Link> */}

                            <div>
                            </div>
                            {/* <img src={seal1} alt="" />
                            <img src={seal2} alt="" /> */}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default SubFooter;


// WEBPACK FOOTER //
// ./src/components/subfooter/subfooter.jsx